import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useErrorHandler } from "./useErrorHandler";
import { useRegisterStore } from "../store/register.store";
import { useLayoutStore } from "../store/layout.store";
import { fetchClientsAsync, createClientAsync } from "../actions/clients.actions";
import { clientSchema } from "../schemas/client.schema";
import { successToastHook } from "../components/toasts/success";

export const useClients = () => {
  const { handleError } = useErrorHandler();
  const { setAsideBarOpened } = useLayoutStore((state) => state);

  const useListClients = () => {
    const { allClients, setAllClients } = useRegisterStore((state) => state);
    const [loading, setLoading] = useState(false);

    const fetchClients = async () => {
      setLoading(true);

      fetchClientsAsync()
        .then((res: any) => {
          setAllClients(res?.data?.theClients || []);
          setLoading(false);
        })
        .catch((error) => {
          setAllClients([]);
          setLoading(false);

          handleError(error);
        });
    };

    useEffect(() => {
      fetchClients();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
      clients: allClients,
      loading,
      refetchClients: fetchClients,
    };
  };

  const useAddEditClient = (id?: string) => {
    const { setAllClients } = useRegisterStore((state) => state);
    const [loading, setLoading] = useState(false);

    const fetchClients = async () => {
      try {
        const res = await fetchClientsAsync();
        setAllClients((res as any)?.data?.theClients || []);
      } catch (error) {
        handleError(error);
      }
    };

    const submitData = ({
      values,
      onSuccess,
    }: {
      values: Yup.InferType<typeof clientSchema>;
      onSuccess?: () => void;
    }) => {
      setLoading(true);

      if (!id) {
        createClientAsync({
          values: values,
        })
          .then(() => {
            setLoading(false);

            successToastHook({ msg: "Client added successfully!" });

            fetchClients();

            setTimeout(() => {
              if (onSuccess) {
                onSuccess();
              }

              setAsideBarOpened(false);
            }, 1000);
          })
          .catch((error) => {
            setLoading(false);

            handleError(error);
          });
      }
    };

    return {
      submitData,
      loading,
    };
  };

  const onCancel = ({ action }: { action?: () => void }) => {
    setAsideBarOpened(false);
    if (action) {
      action();
    }
  };

  return {
    useListClients,
    useAddEditClient,
    onCancel,
  };
};
